import axios from "axios";
import { getAuthorizationToken } from "../config/user";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function addNewCase(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/addcase`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
export const getUser = async () => {
  try {
    let user = localStorage.getItem("userDetails");
    if (user === null) {
      return { hospital: {}, user: {} };
    }
    return JSON.parse(user);
  } catch (error) {
    console.error("Error getting user data:", error);
    return { hospital: {}, user: {} };
  }
};

function updateDocumentScrapData(data, documentId) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-document-scrap-data?documentId=${documentId}`,
    data,
    headers: getAuthorizationToken(),
  });
}

function addCaseProcedure(data, caseId) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-case-procedure/${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function updateCaseProcedures(data, caseId) {
  return axios({
    method: "patch",
    url: `${REACT_APP_API_URL}/update-case-procedures/${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function updateMappedDocuments(data, caseId) {
  return axios({
    method: "patch",
    url: `${REACT_APP_API_URL}/update-mapped-documents/${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function mappingPendingCases(page, limit) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/mapping-pending-cases?page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}

function defaultDocuments(procedureIds, caseType = "SURGICAL") {
  procedureIds = encodeURIComponent(JSON.stringify(procedureIds));
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-documents/${procedureIds}?caseType=${caseType}`,
    data: procedureIds,
    headers: getAuthorizationToken(),
  });
}

function getAllDefaultDocuments(procedureId = null) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-documents/${procedureId}`,
    headers: getAuthorizationToken(),
  });
}

function deactivateCase(caseId, event, reason) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/deactivate-case/${caseId}?event=${event}`,
    data: { reason: reason },
    headers: getAuthorizationToken(),
  });
}

function allCases(
  searchKey,
  searchPmjayId,
  page,
  limit,
  assignedFilter,
  caseType,
  caseStatus,
  caseId,
  hospitalIds,
  nextStepUser,
  commandCenterStage,
  teamUserId,
  selectedStage,
  caseSubType,
  isTpa = "",
) {
  const isTpaParam =
    isTpa === 0 || isTpa === 1 || isTpa === "0" || isTpa === "1"
      ? `&isTpa=${isTpa}`
      : "";
  return selectedStage
    ? axios({
        method: "get",
        url: `${REACT_APP_API_URL}/all-cases?searchKey=${searchKey}&pmjayId=${searchPmjayId}&page=${page}&limit=${limit}&ownershipStatus=${assignedFilter}&caseType=${caseType}&status=${caseStatus}&caseId=${caseId}&hospitalIds=${encodeURIComponent(
          JSON.stringify(hospitalIds),
        )}&nextStepUser=${nextStepUser}&commandCenterStage=${commandCenterStage}&assignedTo=${teamUserId}&commandCenterStages=${encodeURIComponent(
          JSON.stringify(selectedStage),
        )}&caseSubType=${caseSubType}${isTpaParam}`,

        headers: getAuthorizationToken(),
      })
    : axios({
        method: "get",
        url: `${REACT_APP_API_URL}/all-cases?searchKey=${searchKey}&pmjayId=${searchPmjayId}&page=${page}&limit=${limit}&ownershipStatus=${assignedFilter}&caseType=${caseType}&status=${caseStatus}&caseId=${caseId}&hospitalIds=${encodeURIComponent(
          JSON.stringify(hospitalIds),
        )}&nextStepUser=${nextStepUser}&commandCenterStage=${commandCenterStage}&assignedTo=${teamUserId}&caseSubType=${caseSubType}${isTpaParam}`,
        headers: getAuthorizationToken(),
      });
}
function allCasesBeta(
  searchKey,
  searchPmjayId,
  page,
  limit,
  assignedFilter,
  caseType,
  caseStatus,
  caseId,
  hospitalIds,
  nextStepUser,
  commandCenterStage,
  teamUserId,
  selectedStage,
  isTpa = "",
) {
  const isTpaParam =
    isTpa === 0 || isTpa === 1 || isTpa === "0" || isTpa === "1"
      ? `&isTpa=${isTpa}`
      : "";
  return selectedStage
    ? axios({
        method: "get",
        url: `${REACT_APP_API_URL}/beta-all-cases?searchKey=${searchKey}&pmjayId=${searchPmjayId}&page=${page}&limit=${limit}&ownershipStatus=${assignedFilter}&caseType=${caseType}&status=${caseStatus}&caseId=${caseId}&hospitalIds=${encodeURIComponent(
          JSON.stringify(hospitalIds),
        )}&nextStepUser=${nextStepUser}&commandCenterStage=${commandCenterStage}&assignedTo=${teamUserId}&commandCenterStages=${encodeURIComponent(
          JSON.stringify(selectedStage),
        )}${isTpaParam}`,

        headers: getAuthorizationToken(),
      })
    : axios({
        method: "get",
        url: `${REACT_APP_API_URL}/beta-all-cases?searchKey=${searchKey}&pmjayId=${searchPmjayId}&page=${page}&limit=${limit}&ownershipStatus=${assignedFilter}&caseType=${caseType}&status=${caseStatus}&caseId=${caseId}&hospitalIds=${encodeURIComponent(
          JSON.stringify(hospitalIds),
        )}&nextStepUser=${nextStepUser}&commandCenterStage=${commandCenterStage}&assignedTo=${teamUserId}${isTpaParam}`,
        headers: getAuthorizationToken(),
      });
}

function unassignedCaseCount(
  searchKey,
  searchPmjayId,
  page,
  limit,
  assignedFilter,
  caseType,
  caseStatus,
  caseId,
  hospitalIds,
  nextStepUser,
  commandCenterStage,
  teamUserId,
  selectedStage,
  isTpa = "",
) {
  const isTpaParam =
    isTpa === 0 || isTpa === 1 || isTpa === "0" || isTpa === "1"
      ? `&isTpa=${isTpa}`
      : "";
  return selectedStage
    ? axios({
        method: "get",
        url: `${REACT_APP_API_URL}/unassigned-case-count?searchKey=${searchKey}&pmjayId=${searchPmjayId}&page=${page}&limit=${limit}&ownershipStatus=${assignedFilter}&caseType=${caseType}&status=${caseStatus}&caseId=${caseId}&hospitalIds=${encodeURIComponent(
          JSON.stringify(hospitalIds),
        )}&nextStepUser=${nextStepUser}&commandCenterStage=${commandCenterStage}&assignedTo=${teamUserId}&commandCenterStages=${encodeURIComponent(
          JSON.stringify(selectedStage),
        )}${isTpaParam}`,

        headers: getAuthorizationToken(),
      })
    : axios({
        method: "get",
        url: `${REACT_APP_API_URL}/unassigned-case-count?searchKey=${searchKey}&pmjayId=${searchPmjayId}&page=${page}&limit=${limit}&ownershipStatus=${assignedFilter}&caseType=${caseType}&status=${caseStatus}&caseId=${caseId}&hospitalIds=${encodeURIComponent(
          JSON.stringify(hospitalIds),
        )}&nextStepUser=${nextStepUser}&commandCenterStage=${commandCenterStage}&assignedTo=${teamUserId}${isTpaParam}`,
        headers: getAuthorizationToken(),
      });
}

function getCaseDetails(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-details/${caseId}`,
    headers: getAuthorizationToken(),
  });
}

function getCaseProcedures(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-procedures/${caseId}`,
    headers: getAuthorizationToken(),
  });
}

function subscriptionall() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/subscription-plan`,
    headers: getAuthorizationToken(),
  });
}

function currentPlan() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/active-subscription-plan`,
    headers: getAuthorizationToken(),
  });
}

function addMapDocuments(data, caseId) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-map-document?caseId=${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function getMappedDocuments(caseId, documentType) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/mapped-document/${caseId}?documentType=${
      documentType || ""
    }`,
    headers: getAuthorizationToken(),
  });
}

function saveDocumentUrl(
  documentId,
  documentUrl,
  completeDocReupload,
  isDocApproved = false,
) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/save-document-url/${documentId}?completeDocReupload=${completeDocReupload}&isDocApproved=${isDocApproved}`,
    headers: getAuthorizationToken(),
    data: documentUrl,
  });
}

function updateCase(data, caseId) {
  return axios({
    method: "patch",
    url: `${REACT_APP_API_URL}/update-case/${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function defaultSpecialityList(
  searchKey,
  page,
  hospitalState = "Uttar Pradesh",
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-specialities?searchKey=${searchKey}&page=${page}&state=${hospitalState}`,
    headers: getAuthorizationToken(),
  });
}

function defaultProcedureNameList(
  speciality,
  searchKey,
  page,
  hospitalState = "Uttar Pradesh",
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-procedure-list?state=${hospitalState}`,
    params: {
      speciality: speciality,
      searchKey: searchKey,
      page: page,
    },
    headers: getAuthorizationToken(),
  });
}
function deleteDocumentImage(urlId) {
  return axios({
    method: "delete",
    url: `${REACT_APP_API_URL}/delete-document-url/${urlId}`,
    headers: getAuthorizationToken(),
  });
}
function updateDocumentStatus(documentId, data, currentRole) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-document-status/${documentId}?currentRole=${currentRole}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function updateMultipleDocumentStatus(data, currentRole) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/multiple-documents-status-update?currentRole=${currentRole}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function initiateAdmission(caseId, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/initiate-admission/?caseId=${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function deleteDocument(documentId, deleteUploadedDoc) {
  return axios({
    method: "delete",
    url: `${REACT_APP_API_URL}/delete-mapped-document/${documentId}?deleteUploadedDoc=${deleteUploadedDoc}`,
    headers: getAuthorizationToken(),
  });
}
function defaultDocumentsWithoutGrouping(
  page,
  limit,
  searchKey,
  procedureId,
  speciality,
  procedure,
  specialityId,
  implants,
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-documents-without-grouping?searchKey=${searchKey}&page=${page}&limit=${limit}&procedureId=${procedureId}`,
    headers: getAuthorizationToken(),
  });
}
function defaultDocumentForSuggestionBox(search, page) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-documents-without-grouping?searchKey=${search}&page=${page}&limit=${10}`,
    headers: getAuthorizationToken(),
  });
}
function defaultDocumentsWithoutGroup({
  searchKey,
  page = 1,
  limit = 20,
  procedureId,
  specialityId,
  implants,
  stratification,
  caseType,
  documentType,
}) {
  // remove empty params
  const params = Object.fromEntries(
    Object.entries({
      searchKey,
      page,
      limit,
      procedureId,
      specialityId,
      implants,
      stratification,
      caseType,
      documentType,
    }).filter(([_, v]) => v !== "" && v !== undefined && v !== null),
  );

  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-documents-without-grouping`,
    params,
    headers: getAuthorizationToken(),
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        console.error("[API ERR]", err.response.status, err.response.data);
      } else {
        console.error("[API ERR]", err.message);
      }
      throw err;
    });
}

function addEnhancement(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/add-case-master-details`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function addEnhancementTpa(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/add-case-master-details-tpa`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function getEnhancementsList(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-enhancements/${caseId}`,
    headers: getAuthorizationToken(),
  });
}
function getLatestCaseStage(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/latest-case-stage/${caseId}`,
    params: {
      previousAllDocs: true,
    },
    headers: getAuthorizationToken(),
  });
}
function getNextPossibleSubStages(currentCommandCenterStage) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/next-possible-sub-stages?currentCommandCenterStageStatus=${currentCommandCenterStage}`,
    headers: getAuthorizationToken(),
  });
}

function updateSubMasterStage(caseId, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/sub-master-stage-update/${caseId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function getDefaultProcedureTypeList(procedureId, searchKey = "") {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-procedure-type-list?procedureId=${procedureId}&searchKey=${searchKey}`,

    headers: getAuthorizationToken(),
  });
}

function getProcedureCostList(compositId, city) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/procedure-cost-list?compositId=${compositId}&city=${city}`,
    headers: getAuthorizationToken(),
  });
}
function addDefaultProcedureCost(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-default-procedure-cost`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function procedureAllTierCost(compositId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/procedure-all-tier-cost?compositId=${compositId}`,
    headers: getAuthorizationToken(),
  });
}

function getDefaultProcedure(searchKey, page = 1, limit = 10, state) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-procedure?searchKey=${searchKey}&page=${page}&limit=${limit}&state=${state}`,
    headers: getAuthorizationToken(),
  });
}

function addDefaultDocuments(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-update-default-documents`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function removeDefaultDocument(ids) {
  return axios({
    method: "delete",
    url: `${REACT_APP_API_URL}/delete-default-document?documentIds=${encodeURIComponent(
      JSON.stringify(ids),
    )}`,
    headers: getAuthorizationToken(),
  });
}

function mapSaveQueryDocuments(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/map-save-query-doc`,
    headers: getAuthorizationToken(),
    data: data,
  });
}

function getDischarge(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/discharge-details/${caseId}`,
    headers: getAuthorizationToken(),
  });
}
function getCaseCostDetails(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-cost-detail/${caseId}`,
    headers: getAuthorizationToken(),
  });
}
function stageCaseReport(assignedUserStages) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/stage-case/count-report?commandCenterStages=${
      assignedUserStages.length > 0
        ? encodeURIComponent(JSON.stringify(assignedUserStages))
        : ""
    }`,
    headers: getAuthorizationToken(),
  });
}
function stageCaseReportBeta() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/stage-case/count-report-beta`,
    headers: getAuthorizationToken(),
  });
}
function duringTreatmentDocChecker(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/during-treatment-doc-checker?caseId=${caseId}`,
    headers: getAuthorizationToken(),
  });
}
function getProcedureStateList() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/procedure-state-list`,
    headers: getAuthorizationToken(),
  });
}
async function getUserAssignedCasesCount() {
  const user = await getUser();
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/assigned-case-count?assignedTo=${user?.user?.id}`,
    headers: getAuthorizationToken(),
  });
}
async function handlePreApprovedAdmission(caseId, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/approve-case-for-admission?caseId=${caseId}`,
    headers: getAuthorizationToken(),
    data: data,
  });
}
function getDefaultDocumentNameList(searchKey, page, limit) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/default-document-name-list?searchKey=${searchKey}&page=${page}&limit=${limit}`,
    headers: getAuthorizationToken(),
  });
}
function downloadRefDocs(startDate, endDate) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/download-ref-docs?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
    headers: getAuthorizationToken(),
  });
}
function getInactiveCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/inactive-total-case-count`,
    headers: getAuthorizationToken(),
  });
}
function updateDocRequiredStatus(documentId, status) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-doc-required-status/${documentId}?required=${status ? 1 : 0}`,
    headers: getAuthorizationToken(),
  });
}
function getSubTypeList(caseType) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/master-data-list?type=${caseType}`,
    headers: getAuthorizationToken(),
  });
}
function initiateAdmissionDaycare(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/initiate-admission-daycare?caseId=${data?.caseId}&caseType=${data?.caseType}&caseSubType=${data?.caseSubType}&admissionDate=${data?.admissionDate}`,
    headers: getAuthorizationToken(),
  });
}

function getAdmissionDialysisCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-admission-dailysis-count`,
    headers: getAuthorizationToken(),
  });
}
function getAdmissionDialysisInitiatedCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-admission-dialysis-not-initated-count`,
    headers: getAuthorizationToken(),
  });
}
function getClaimDialysisCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/claim-dialysis-count`,
    headers: getAuthorizationToken(),
  });
}
function getClaimDialysisInitiatedCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/claim-not-initiated-count`,
    headers: getAuthorizationToken(),
  });
}

function getEnhancementDialysisCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/enhancement-dialysis-approval-pending`,
    headers: getAuthorizationToken(),
  });
}

function getEnhancementDialysisInitiatedCaseCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/enhancement-dialysis-initiation-pending`,
    headers: getAuthorizationToken(),
  });
}
function getRpaQueueCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/rpa-queue-count`,
    headers: getAuthorizationToken(),
  });
}

function updateCaseProc(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-case-procedure-daycare?caseId=${data?.caseId}&procedureId=${data?.procedureId}&specialityId=${data?.specialityId}`,
    headers: getAuthorizationToken(),
  });
}

function addDoctorProcedureMapping(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-doctor-procedure-mapping`,
    data: {
      caseId: data?.caseId,
      doctorId: data?.doctorId,
    },
    headers: getAuthorizationToken(),
  });
}
function getDocumentCount(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-doc-enhancement-count?caseId=${caseId}`,
    headers: getAuthorizationToken(),
  });
}
function updateCaseProcessByAI(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/process-case-by-ai`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function holdRejectedCaseByAI(caseId, documentType) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/hold-ai-reject-case?caseId=${caseId}&documentType=${documentType}`,
    headers: getAuthorizationToken(),
  });
}
function reProcessAiAnalysisCases(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/re-process-ai-analysis-case`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function moveAIcaseToReverify(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/move-ai-case-to-reverify`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function getDeletedDocUrls(documentId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/deleted-doc-urls?documentId=${documentId}`,
    headers: getAuthorizationToken(),
  });
}

function initiateErroneousClaim(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/initiate-erroneous-claim`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function updateErroneousClaim(pmjayRegistrationId, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-erroneous-claim?pmjayRegistrationId=${pmjayRegistrationId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function updateReprocessClaim(pmjayRegistrationId, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-reprocess-claim?pmjayRegistrationId=${pmjayRegistrationId}`,
    data: data,
    headers: getAuthorizationToken(),
  });
}

function getTpaTemplate(tpa) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/tpa-template`,
    params: { tpa },
    headers: getAuthorizationToken(),
  });
}

function initiateReprocessClaim(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/initiate-reprocess-claim`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function getTpaCaseCredentials(caseId) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/case-tpa-credentials?caseId=${caseId}`,
    headers: getAuthorizationToken(),
  });
}

export const CaseServices = {
  saveDocumentUrl,
  addNewCase,
  addCaseProcedure,
  getCaseDetails,
  mappingPendingCases,
  defaultDocuments,
  allCases,
  allCasesBeta,
  unassignedCaseCount,
  getCaseProcedures,
  subscriptionall,
  currentPlan,
  addMapDocuments,
  getMappedDocuments,
  updateCase,
  updateCaseProcedures,
  updateMappedDocuments,
  defaultSpecialityList,
  defaultProcedureNameList,
  deleteDocumentImage,
  updateDocumentStatus,
  initiateAdmission,
  defaultDocumentsWithoutGrouping,
  deleteDocument,
  getEnhancementsList,
  addEnhancement,
  getLatestCaseStage,
  getNextPossibleSubStages,
  updateMultipleDocumentStatus,
  defaultDocumentForSuggestionBox,
  updateSubMasterStage,
  getDefaultProcedureTypeList,
  getProcedureCostList,
  addDefaultProcedureCost,
  procedureAllTierCost,
  getDefaultProcedure,
  addDefaultDocuments,
  removeDefaultDocument,
  getDischarge,
  getCaseCostDetails,
  stageCaseReport,
  stageCaseReportBeta,
  duringTreatmentDocChecker,
  deactivateCase,
  getProcedureStateList,
  getUserAssignedCasesCount,
  handlePreApprovedAdmission,
  getAllDefaultDocuments,
  defaultDocumentsWithoutGroup,
  getDefaultDocumentNameList,
  downloadRefDocs,
  getInactiveCaseCount,
  updateDocRequiredStatus,
  getSubTypeList,
  initiateAdmissionDaycare,
  updateCaseProc,
  addDoctorProcedureMapping,
  getAdmissionDialysisCaseCount,
  getAdmissionDialysisInitiatedCaseCount,
  getClaimDialysisCaseCount,
  getClaimDialysisInitiatedCaseCount,
  getEnhancementDialysisCaseCount,
  getEnhancementDialysisInitiatedCaseCount,
  mapSaveQueryDocuments,
  getDocumentCount,
  updateDocumentScrapData,
  updateCaseProcessByAI,
  holdRejectedCaseByAI,
  getRpaQueueCount,
  reProcessAiAnalysisCases,
  moveAIcaseToReverify,
  getDeletedDocUrls,
  initiateErroneousClaim,
  updateErroneousClaim,
  initiateReprocessClaim,
  updateReprocessClaim,
  getTpaTemplate,
  getTpaCaseCredentials,
  addEnhancementTpa,
};
